import React from 'react';
import {observer} from 'mobx-react';

import {H2hWidgetProps} from "../models/h2h-widget.props";
import {H2H} from "../h2h-widget.consts";
import {RecentFormWidgetAsync} from "../../recent-form-widget/components/recent-form-widget.async";
import {PreviousMeetingsWidgetAsync} from "../../previous-meetings-widget/components/previous-meetings-widget.async";
import {H2hWidgetState} from "../models/h2h-widget.state";

export class H2hModuleFullViewComponentProps extends H2hWidgetProps {
  isFullView: Boolean;
  state: H2hWidgetState;
}

export const H2hWidgetFullView = observer(({
                                             controller,
                                             matchupId,
                                             gameId,
                                             isFullView
                                           }: H2hModuleFullViewComponentProps) => {
  const {state} = controller;
  const {tabsSelectedIndex, showOdds} = state;

  const widgetsProps = {
    shouldFilterByHomeAway: tabsSelectedIndex === H2H.TABS_INDEXES.homeAway,
    matchupId: matchupId,
    gameId: gameId,
    isFullView: isFullView,
    showOdds,
  };

  return (
    <>
      <PreviousMeetingsWidgetAsync {...widgetsProps}/>
      <RecentFormWidgetAsync {...widgetsProps}/>
    </>
  )
});
